import React from 'react'
import { graphql, gql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { CURRENCIES, DEFAULT_CURRENCY } from '../../../constants'
import { Form, TextInput, SelectInput } from '../../UI'
import Loader from '../../UI/Loader'

import { validateRequired } from '../../../libs/validation'
import { NotificationManager } from 'react-notifications'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

class TripsForm extends React.Component {
  state = {
    saving: false,
    items: [
      {
        id: 'new_' + _.uniqueId(),
        locationId: null,
        paymentStructure: 'PayPerDay',
        price: 0,
        name: '',
        status: 'Active'
      }
    ],
    currency: 'EUR',
    error: {
      visible: false,
      title: 'You need to have plan for every location!'
    },
    routeIndex: 9
  }

  componentWillMount() {
    const plans = _.get(this, 'props.data.user.plannerProfile.planOffers', [])
    const currency = _.get(this, 'props.data.user.plannerProfile.currency', DEFAULT_CURRENCY)
    if (plans && plans.length) {
      const items = plans.map(plan => {
        return {
          id: plan.id,
          locationId: _.get(plan, 'location.id', ''),
          paymentStructure: plan.paymentStructure,
          price: plan.price,
          name: plan.name,
          status: plan.status
        }
      })
      this.setState({ items, currency })
    }
  }

  componentWillReceiveProps(nextProps) {
    const plans = _.get(this, 'props.data.user.plannerProfile.planOffers', [])
    const plansNext = _.get(nextProps, 'data.user.plannerProfile.planOffers', [])
    const currency = _.get(nextProps, 'data.user.plannerProfile.currency', DEFAULT_CURRENCY)
    if (plans && plansNext && plans.length !== plansNext.length) {
      const items = plansNext.map(plan => {
        return {
          id: plan.id,
          locationId: _.get(plan, 'location.id', ''),
          paymentStructure: plan.paymentStructure,
          price: plan.price,
          name: plan.name,
          status: plan.status
        }
      })
      this.setState({ items, currency })
    }
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    const { locations } = this.props.data.user.plannerProfile
    let currentLocations = {}

    for (let item in values) {
      let index = item.indexOf('_')
      let itemType = item.slice(0, index)

      if (itemType === 'location') {
        currentLocations[values[item]] = values[item]
      }
    }

    let checkLocations = []
    locations.forEach(l => {
      for (let item in currentLocations) {
        if (l.id === currentLocations[item]) {
          checkLocations.push(currentLocations[item])
        }
      }
    })
    if (checkLocations.length < locations.length) {
      this.setState({ error: Object.assign({}, this.state.error, { visible: true }) })
    } else {
      const currentPlans = this.state.items

      var newPlans = [],
        updatedPlans = []
      const { plannerProfile } = this.props.data.user
      let currency
      for (let item in values) {
        let index = item.indexOf('_')
        let nextId = item.slice(index + 1)
        let itemType = item.slice(0, index)
        if (values.hasOwnProperty(item) && values[item] && itemType === 'location') {
          currency = values['currency_' + nextId]
          let plan = {
            locationId: values[item],
            paymentStructure: values['payment_' + nextId],
            name: values['name_' + nextId],
            price: +values['price_' + nextId],
            status: 'Active'
          }
          let newPlan = false
          if (!nextId.startsWith('new_')) {
            plan.id = nextId
            // If this is an existing object we need to determine if there is a change. If so we create a new version
            // otherwise ignore
            let curr = currentPlans[currentPlans.findIndex(i => i.id === nextId)]
            if (curr && !_.isEqual(curr, plan)) {
              // Item changed - create a new version, make the current one deleted.
              curr.status = 'Deleted'
              updatedPlans.push(curr)
              plan.id = null
              newPlan = true
            }
          } else {
            newPlan = true
          }
          if (newPlan) {
            plan.plannerProfileId = plannerProfile.id
            newPlans.push(plan)
          }
        }
      }

      updatedPlans = updatedPlans.concat(this.getRemovedPlans(updatedPlans))

      this.setState({ saving: true, error: Object.assign({}, this.state.error, { visible: false }) })

      const updatePromises = updatedPlans.map(plan => {
        return this.props.updatePlanOffer({
          variables: plan
        })
      })

      const createPromises = newPlans.map(plan => {
        return this.props.createPlanOffer({
          variables: {
            price: plan.price,
            name: plan.name,
            locationId: plan.locationId,
            paymentStructure: plan.paymentStructure,
            status: plan.status,
            plannerProfileId: plan.plannerProfileId
          }
        })
      })
      Promise.all([
        ...updatePromises,
        ...createPromises,
        this.props.updatePlannerProfile({
          variables: {
            id: plannerProfile.id,
            currency
          }
        })
      ])
        .then(result => {
          this.props.data.refetch()
          NotificationManager.success('Tailored trip cost updated', 'Success', 5000)
          this.setState({
            saving: false
          })
          this.props.history.push('/create-guru-profile/services')
        })
        .catch(err => {
          this.setState({
            saving: false
          })
          NotificationManager.error('error while updating tailored trip cost', 'Error', 5000)
        })
    }
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: 'new_' + _.uniqueId(),
          locationId: null,
          paymentStructure: 'PayPerDay',
          price: 0,
          name: '',
          status: 'Active'
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.map(item => {
      if (item.id === id) {
        item.status = 'Deleted'
      }
      return item
    })
    this.setState({ items })
  }

  handleCurrencyChange = (id, value) => {
    this.setState({
      currency: value
    })
    for (let el in this) {
      if (this.hasOwnProperty(el) && el.slice(0, 9) === 'currency_') {
        this[el].overrideValue(value)
      }
    }
  }

  getRemovedPlans = selectedPlans => {
    const currentPlans = this.state.items
    let removedPlans = []
    if (currentPlans) {
      removedPlans = currentPlans.filter(function(el) {
        return el.id.startsWith('new_') ? false : selectedPlans.findIndex(i => i.id === el.id) < 0
      })
    }
    return removedPlans
  }

  getCurrencyOptions = () => {
    const options = []
    for (let currency in CURRENCIES) {
      if (CURRENCIES.hasOwnProperty(currency)) {
        options.push({
          label: CURRENCIES[currency],
          value: currency
        })
      }
    }
    return options
  }

  /*eslint no-unreachable: "off"*/
  getPaymentCategoryName = paymentCategory => {
    switch (paymentCategory) {
      case 'PayOneWeekPeriod':
        return 'Pay One Week Period'
        break
      case 'PayTwoWeekPeriod':
        return 'Pay Two Week Period'
        break
      case 'PayThreeWeekPeriod':
        return 'Pay Three Week Period'
        break
      case 'PayForMonth':
        return 'Pay For Month'
        break
      case 'PayPerDay':
        return 'Pay Per Day'
        break
      default:
        return paymentCategory
    }
  }

  getLocationOptions = () => {
    const { locations } = this.props.data.user[0].plannerProfile
    return locations.map(location => {
      return {
        label: location.description,
        value: location.id
      }
    })
  }

  getPlanPricingOptions = () => {
    const { t } = this.props
    const options = [
      { label: this.getPaymentCategoryName(t('plans_PayPerDay')), value: 'PayPerDay' },
      { label: this.getPaymentCategoryName(t('plans_PayOneWeekPeriod')), value: 'PayOneWeekPeriod' },
      { label: this.getPaymentCategoryName(t('plans_PayTwoWeekPeriod')), value: 'PayTwoWeekPeriod' },
      { label: this.getPaymentCategoryName(t('plans_PayThreeWeekPeriod')), value: 'PayThreeWeekPeriod' },
      { label: this.getPaymentCategoryName(t('plans_PayForMonth')), value: 'PayForMonth' },
      { label: this.getPaymentCategoryName(t('plans_PayForMoreThanMonth')), value: 'PayForMoreThanMonth' }
    ]
    return options
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { t } = this.props
    const { saving, items, currency } = this.state

    return (
      <div className="steps-screen__form faded-container">
        <div className="row">
          <div className="steps-screen__form-title">{t('tailored_trip_plans_cost')}</div>
          <div className="steps-screen__form-subtitle">{t('tailored_trip_plans_cost_description')}</div>
        </div>
        <div className="row">
          <Form
            onSubmit={this.handleSubmit}
            submitBtnClassname="btn btn-lg btn-primary btn-danger"
            submitBtnName={t('main:save_continue')}
            submittingToServer={saving}
          >
            <div className="steps-screen__form-input-area">
              <div>
                {items
                  .filter(el => {
                    return el.status === 'Active'
                  })
                  .map(el => {
                    return (
                      <div key={el.id} className="removable-item-row">
                        <div className="col-md-9 row">
                          <div className="row">
                            <div className="form-group clearfix">
                              <div className="col-md-12">
                                <TextInput
                                  id={`name_${el.id}`}
                                  placeholder={t('enter_plan_name')}
                                  initialValue={el.name}
                                  validationFuncs={[validateRequired]}
                                  maxChars={30}
                                  label={t('plan_name')}
                                  labelClass="steps-screen__form-input-label"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <SelectInput
                                options={this.getLocationOptions()}
                                id={`location_${el.id}`}
                                placeholder={t('destination')}
                                initialValue={el.locationId || null}
                                validationFuncs={[validateRequired]}
                                simpleValue
                                label={t('destination')}
                                labelClass="steps-screen__form-input-label"
                                clearable={false}
                              />
                            </div>
                            <div className="col-sm-6">
                              <SelectInput
                                options={this.getPlanPricingOptions()}
                                id={`payment_${el.id}`}
                                validationFuncs={[validateRequired]}
                                initialValue={el.paymentStructure}
                                simpleValue
                                label={t('plan_payment_structure')}
                                labelClass="steps-screen__form-input-label"
                                clearable={false}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <TextInput
                                id={`price_${el.id}`}
                                placeholder={t('main:enter_price')}
                                initialValue={'' + el.price}
                                validationFuncs={[validateRequired]}
                                label={t('main:price')}
                                labelClass="steps-screen__form-input-label"
                                isGroup={true}
                              />
                            </div>

                            <div className="col-md-6">
                              <SelectInput
                                ref={sel => {
                                  this[`currency_${el.id}`] = sel
                                }}
                                options={this.getCurrencyOptions()}
                                id={`currency_${el.id}`}
                                placeholder={t('main:select_currency')}
                                initialValue={currency}
                                validationFuncs={[validateRequired]}
                                simpleValue
                                onChangeExternal={this.handleCurrencyChange}
                                label={t('main:currency')}
                                labelClass="steps-screen__form-input-label"
                                clearable={false}
                                isGroup={true}
                              />
                            </div>
                          </div>
                        </div>
                        {items.length > 1 && (
                          <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                            <span className="icon-close" /> {t('main:remove')}
                          </div>
                        )}
                      </div>
                    )
                  })}
              </div>
              <div className="error" style={{ display: this.state.error.visible ? 'block' : 'none' }}>
                {this.state.error.title}
              </div>
              <div className="add-item-link" onClick={this.handleAddClick}>
                <span className="icon-plus" /> {t('add_trip')}
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

const createPlanOffer = gql`
  mutation(
    $plannerProfileId: ID
    $price: Int!
    $name: String!
    $locationId: ID
    $paymentStructure: PlansPaymentStructure!
    $status: LifeStatus!
  ) {
    createPlanOffer(
      plannerProfileId: $plannerProfileId
      price: $price
      name: $name
      paymentStructure: $paymentStructure
      status: $status
      locationId: $locationId
    ) {
      id
    }
  }
`

const updatePlanOffer = gql`
  mutation($id: ID!, $price: Int!, $name: String!, $location: ID, $paymentStructure: PlansPaymentStructure!, $status: LifeStatus!) {
    updatePlanOffer(id: $id, price: $price, name: $name, locationId: $location, paymentStructure: $paymentStructure, status: $status) {
      id
      price
      paymentStructure
      name
      location {
        id
      }
      status
    }
  }
`

const updatePlannerProfile = gql`
  mutation($id: ID!, $currency: String!) {
    updatePlannerProfile(id: $id, currency: $currency) {
      id
    }
  }
`

/*
const updatePlannerProfile = gql`
  mutation (
    $id: ID!,
    $currency: String!,
    $plans: [PlannerProfileplanOffersPlanOffer!]
  ) {
    updatePlannerProfile(
      id: $id,
      currency: $currency,
      planOffers: $plans
    ) {
      id
    }
  }
`;
*/

const userQuery = gql`
  query userQuery {
    user {
      id
      plannerProfile {
        id
        currency
        locations {
          id
          country
        }
        planOffers {
          id
          price
          paymentStructure
          name
          location {
            id
          }
          status
        }
        locations {
          id
          description
        }
      }
    }
  }
`

const TranslatedTripsForm = translate('guru')(TripsForm)

export default compose(
  graphql(updatePlanOffer, { name: 'updatePlanOffer' }),
  graphql(createPlanOffer, { name: 'createPlanOffer' }),
  graphql(updatePlannerProfile, { name: 'updatePlannerProfile' }),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })
)(withRouter(TranslatedTripsForm))



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/TripsForm.jsx